export default __webpack_public_path__ + "static/twitter-56ca3599f9f31cb580c689b83c888223.svg";